import React, { useState } from 'react';
import { ChevronDown, ChevronUp, MessageSquare, Send } from 'lucide-react';

/** @param {{comments?:Array, onAddComment:(id:string,text:string)=>void, entryId:string}} props */
export default function CommentsPanel({ comments, onAddComment, entryId }) {
  const [newComment, setNewComment] = useState('');
  const [showComments, setShowComments] = useState(false);

    // Debug - log EVERY time this renders with comments
  console.log('CommentsPanel render:', { 
    entryId, 
    commentsCount: comments?.length,
    hasComments: !!comments && comments.length > 0,
    firstComment: comments?.[0]
  });

  const submit = () => {
    if (!newComment.trim()) return;
    onAddComment(entryId, newComment.trim());
    setNewComment('');
  };

  return (
    <div className="mt-4 border-t border-slate-200 pt-4">
      <button
        onClick={() => setShowComments(!showComments)}
        className="flex items-center space-x-2 text-sm text-slate-600 hover:text-slate-800"
      >
        <MessageSquare className="w-4 h-4" />
        <span>Comments ({comments?.length || 0})</span>
        {showComments ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>

      {showComments && (
        <div className="mt-3 space-y-3">
          {comments && comments.length > 0 ? (
            comments.map((c) => {
              // Handle the nested user_profiles structure
              const userName = c.user_profiles?.full_name || c.user_profiles?.email || 'Unknown User';
              
              return (
                <div key={c.id} className="bg-slate-50 rounded-lg p-3">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-slate-700">
                      {userName}
                    </span>
                    <span className="text-xs text-slate-500">
                      {new Date(c.created_at).toLocaleDateString()} at {new Date(c.created_at).toLocaleTimeString()}
                    </span>
                  </div>
                  <p className="text-sm text-slate-600">{c.comment_text}</p>
                  {c.is_system_comment && (
                    <span className="inline-block mt-1 text-xs text-slate-500 italic">System comment</span>
                  )}
                </div>
              );
            })
          ) : (
            <p className="text-sm text-slate-500 italic">No comments yet</p>
          )}
          
          <div className="flex space-x-2">
            <input
              type="text"
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              onKeyDown={(e) => { 
                if (e.key === 'Enter' && !e.shiftKey) { 
                  e.preventDefault(); 
                  submit(); 
                } 
              }}
              placeholder="Add a comment..."
              className="flex-1 px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={submit}
              disabled={!newComment.trim()}
              className="px-3 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              title="Send"
            >
              <Send className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}